import script from "./WebVideoCollection.vue?vue&type=script&setup=true&lang=js"
export * from "./WebVideoCollection.vue?vue&type=script&setup=true&lang=js"

import "./WebVideoCollection.vue?vue&type=style&index=0&id=438ca754&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-438ca754"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QImg,QIcon});
